import React, { useState } from "react";
import{ useSelector } from "react-redux";
import CustomLoaderSmall from "../../../src/components/Layout/CustomLoaderSmall";

import {
    CalendarDays,
    LucideUserRoundPlus,
    Timer,
    User, Search,
} from "lucide-react";

import NavigationSideBar from "../../components/Layout/Graph & Tables/NavigationSideBar";
import DashboardHeader from "../../components/Layout/DashBoardHeader";
import StackCard from "../../components/Layout/StackCard";
import {useGetAllUsersQuery, useDeleteUserMutation, useFetchEmployeeByProjectIdListQuery } from "../../../src/features/userApiSlice";

import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {useNavigate, NavLink, useParams} from "react-router-dom";
import {useGetCurrentWorkSessionQuery} from "../../../src/features/attendanceApiSlice";


export default function UserTableScreen() {

    /* --------------------------------------------------------
    State
 -------------------------------------------------------- */

    const [searchTerm, setSearchTerm] = useState("");

    const [statusFilter, setStatusFilter] =
        useState<"All" | "Working" | "Off">("All");

    const [projectFilter, setProjectFilter] =
        useState("All");

    const [currentPage, setCurrentPage] =
        useState(1);

    const employeesPerPage = 10;

    const {id} = useParams();
    const {userInfo} = useSelector((state: any) => state).auth;
    const userId = userInfo?.id;
    const {data: users, isLoading, refetch} = useFetchEmployeeByProjectIdListQuery(id);
    const deleteUser = useDeleteUserMutation(userId);

    const {data: currentSession } = useGetCurrentWorkSessionQuery(userId);

    const activeProjectId = currentSession?.userSession?.projectId ?? null;
    const activeProjectName = currentSession?.userSession?.projectName ?? null;


    const navigate = useNavigate();

    const handleEmployeeRegistration = () => {
        navigate("createEmployee");
    };


    /* ========================================================
       Employee Navigation
    ======================================================== */

    const handleEmployeeClick = (
        userId: string
    ) => {

        navigate(
            `/profile/${id}/${userId}`
        );
    };

    return (
        <main>
            <Helmet>
                <title>Users Table</title>

                <meta
                    name="description"
                    content="Users Table"
                />
            </Helmet>

            {isLoading ? (
                <CustomLoaderSmall />
            ) : (
                <motion.div
                    initial={{
                        opacity: 0,
                        y: 20,
                    }}
                    animate={{
                        opacity: 1,
                        y: 0,
                    }}
                    transition={{
                        delay: 0.2,
                    }}
                >
                    <div className={" bg-[#0A0A0A] text-white flex min-h-dvh"}>
                        {/* ==================================================
                        Sidebar
                    ================================================== */}
                        <div className={"hidden lg:block"}>
                            <NavigationSideBar />
                        </div>

                        {/* ==================================================
                        Main Content
                    ================================================== */}
                        <div className={"flex-1 flex min-w-0 flex-col"}>
                            <DashboardHeader projectId={id}/>

                            <main className="
                            w-full
                            max-w-[1600px]
                            mx-auto

                            px-4
                            sm:px-6
                            md:px-8
                            lg:px-10

                            py-5
                            sm:py-6
                            md:py-8

                            pb-[env(safe-area-inset-bottom)]">
                                <section className="p-4 sm:p-6 lg:p-8 container mx-auto w-full">
                                    <div className={"flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6"}>
                                        <div className={"flex items-center gap-3"}>
                                            <div className="
                                            w-11
                                            h-11
                                            rounded-full
                                            bg-blue-500/10
                                            border
                                            border-blue-500/20
                                            flex
                                            items-center
                                            justify-center
                                        ">
                                                <User
                                                    size={24}
                                                    className="text-blue-600"
                                                />
                                            </div>
                                            <div>
                                                <h1 className="
                                                text-2xl
                                                font-bold
                                                text-white
                                            ">
                                                    Users Profile
                                                </h1>

                                                <p className="
                                                text-white
                                                text-sm
                                                mt-1
                                            ">
                                                </p>

                                            </div>
                                        </div>

                                        <NavLink
                                            to={`/createEmployee/${id}`}
                                            className="
                                            flex
                                            items-center
                                            justify-center
                                            gap-2
                                            px-4
                                            py-3
                                            bg-blue-600
                                            hover:bg-blue-500
                                            rounded-lg
                                            text-sm
                                            font-medium
                                            transition-colors
    "
                                        >
                                            <LucideUserRoundPlus size={17} />
                                            Add Employee
                                        </NavLink>

                                    </div>

                                    <div className="
                                grid
                                grid-cols-1
                                sm:grid-cols-2
                                lg:grid-cols-4
                                gap-4
                                mb-6
                            ">

                                        <StackCard
                                            icon={Timer}
                                            name="Registed Users"
                                            value={users?.length}
                                            color="#8B5CF6"
                                        />


                                        <StackCard
                                            icon={CalendarDays}
                                            name="Total hours to date"
                                            value={""}
                                            color="#06B6D4"
                                        />

                                    </div>

                                    {/* ==================================================
                                Search / Filters
                            ================================================== */}
                                    <div
                                        className="
                                    bg-[#101010]
                                    border
                                    border-gray-800
                                    rounded-lg
                                    p-4
                                    mb-6
                                "
                                    >
                                        <div
                                            className="
                                        flex
                                        flex-col
                                        lg:flex-row
                                        lg:items-center
                                        lg:justify-between
                                        gap-4
                                    "
                                        >

                                            {/* Search */}

                                            <div
                                                className="
                                            relative
                                            w-full
                                            lg:max-w-md
                                        "
                                            >

                                                <Search
                                                    size={18}
                                                    className="
                                                absolute
                                                left-3
                                                top-1/2
                                                -translate-y-1/2
                                                text-gray-500
                                            "
                                                />

                                                <input
                                                    type="text"
                                                    value={
                                                        searchTerm
                                                    }
                                                    onChange={(
                                                        event
                                                    ) => {

                                                        setSearchTerm(
                                                            event.target.value
                                                        );

                                                        setCurrentPage(
                                                            1
                                                        );
                                                    }}
                                                    placeholder="
                                                Search employee,
                                                email, or project...
                                            "
                                                    className="
                                                w-full
                                                bg-[#0A0A0A]
                                                border
                                                border-gray-800
                                                rounded-lg
                                                py-2.5
                                                pl-10
                                                pr-4
                                                text-sm
                                                text-white
                                                placeholder:text-gray-600
                                                focus:outline-none
                                                focus:border-blue-500
                                            "
                                                />

                                            </div>


                                            {/* Filters */}

                                            <div
                                                className="
                                            flex
                                            flex-col
                                            sm:flex-row
                                            gap-3
                                        "
                                            >

                                                <select
                                                    value={
                                                        statusFilter
                                                    }
                                                    onChange={(
                                                        event
                                                    ) => {

                                                        setStatusFilter(
                                                            event
                                                                .target
                                                                .value as
                                                                | "All"
                                                                | "Working"
                                                                | "Off"
                                                        );

                                                        setCurrentPage(
                                                            1
                                                        );
                                                    }}
                                                    className="
                                                bg-[#0A0A0A]
                                                border
                                                border-gray-800
                                                rounded-lg
                                                px-4
                                                py-2.5
                                                text-sm
                                                text-gray-300
                                                focus:outline-none
                                                focus:border-blue-500
                                            "
                                                >

                                                    <option value="All">
                                                        All Status
                                                    </option>

                                                    <option value="Registered">
                                                        Registered
                                                    </option>

                                                    <option value="Off">
                                                        Not Registered
                                                    </option>

                                                </select>
                                            </div>
                                        </div>

                                    </div>

                                    {/* ==================================================
                                Employee Table
                            ================================================== */}
                                    <div
                                        className="
                                    bg-[#101010]
                                    border
                                    border-gray-800
                                    rounded-lg
                                    overflow-hidden
                                    mb-3
                                "
                                    >
                                        <div className={"p-4 border-b border-gray-800"}>
                                            <div
                                                className="
                                            flex
                                            flex-col
                                            sm:flex-row
                                            sm:items-center
                                            sm:justify-between
                                            gap-1
                                        "
                                            >
                                                <div className={"flex flex-row justify-items-center gap-x-2"}>
                                                    <h2 className={"text-lg font-semibold text-white"}>
                                                        Employee Information
                                                    </h2>
                                                </div>


                                            </div>
                                        </div>

                                        <div className={"overflow-x-auto"}>
                                            <table className={"w-full text-left min-w-[1050px]"}>
                                                <thead className={"bg-gray-900/50"}>
                                                <tr>
                                                    <th
                                                        className="
                                                        p-4
                                                        text-xs
                                                        font-semibold
                                                        text-gray-400
                                                        uppercase
                                                    "
                                                    >
                                                        User Name
                                                    </th>


                                                    <th
                                                        className="
                                                        p-4
                                                        text-xs
                                                        font-semibold
                                                        text-gray-400
                                                        uppercase
                                                    "
                                                    >
                                                        Employee Number
                                                    </th>


                                                    <th
                                                        className="
                                                        p-4
                                                        text-xs
                                                        font-semibold
                                                        text-gray-400
                                                        uppercase
                                                    "
                                                    >
                                                        Email
                                                    </th>


                                                    <th
                                                        className="
                                                        p-4
                                                        text-xs
                                                        font-semibold
                                                        text-gray-400
                                                        uppercase
                                                    "
                                                    >
                                                        Phone Number
                                                    </th>


                                                    <th
                                                        className="
                                                        p-4
                                                        text-xs
                                                        font-semibold
                                                        text-gray-400
                                                        uppercase
                                                    "
                                                    >
                                                        Position
                                                    </th>


                                                    <th
                                                        className="
                                                        p-4
                                                        text-xs
                                                        font-semibold
                                                        text-gray-400
                                                        uppercase
                                                    "
                                                    >
                                                        Assigned Project
                                                    </th>


                                                    <th
                                                        className="
                                                        p-4
                                                        text-xs
                                                        font-semibold
                                                        text-gray-400
                                                        uppercase
                                                    "
                                                    >
                                                        Site ID
                                                    </th>

                                                    <th
                                                        className="
                                                        p-4
                                                    "
                                                    />
                                                </tr>
                                                </thead>

                                                {users?.map((user) => (
                                                    <motion.tr
                                                        key={
                                                            user.id
                                                        }
                                                        initial={{
                                                            opacity: 0,
                                                        }}
                                                        animate={{
                                                            opacity: 1,
                                                        }}
                                                        onClick={() =>
                                                            handleEmployeeClick(
                                                                user.id
                                                            )
                                                        }
                                                        className="
                                                            border-t
                                                            border-gray-800
                                                            hover:bg-gray-900/60
                                                            cursor-pointer
                                                            transition-colors
                                                        "
                                                    >
                                                        {/* Employee */}
                                                        <td className={"p-3"}>
                                                            <div className={"flex items-center gap-2"}>
                                                                <div
                                                                    className='h-10 w-10 rounded-full bg-gradient-to-r from-purple-600 to-blue-500 flex items-center justify-center text-white font-semibold'>

                                                                    {user.userName?.split(" ")
                                                                        ?.map(name => name[0])
                                                                        ?.slice(0, 10)
                                                                        ?.join("")
                                                                        ?.toUpperCase()}
                                                                </div>
                                                                <div className={"items-center"}>
                                                                    <p className={"text-gray-200 font-medium"}>
                                                                        {user.userName}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td className={"p-4 text-gray-300"}>
                                                            <p className={"text-gray-200 font-medium"}>
                                                                # {user.employeeNumber}
                                                            </p>
                                                        </td>

                                                        <td className={"p-4 text-gray-300"}>
                                                            <p className={"text-gray-200 font-medium"}>
                                                                {user.email}
                                                            </p>
                                                        </td>

                                                        <td className={"p-4 text-gray-300"}>
                                                            <p className={"text-gray-200 font-medium"}>
                                                                {user.phoneNumber}
                                                            </p>
                                                        </td>

                                                        <td className={"p-4 text-gray-300"}>
                                                            <p className={"text-gray-200 font-medium"}>
                                                                Field Supervisor
                                                            </p>
                                                        </td>

                                                        <td className={"p-4 text-gray-300"}>
                                                            <p className={"text-gray-200 font-medium"}>
                                                                Vandelay SPC-5A
                                                            </p>
                                                        </td>

                                                        <td className={"p-4 text-gray-300"}>
                                                            <p className={"text-gray-200 font-medium"}>
                                                                Clarksville ID
                                                            </p>
                                                        </td>
                                                    </motion.tr>
                                                ))}
                                            </table>
                                        </div>

                                    </div>
                                </section>
                            </main>
                        </div>

                    </div>

                </motion.div>
            )}
        </main>
    )
}